module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Hanna.5b09253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Hanna.jpg
// module id = vvFd
// module chunks = 0